import { api, getApiUrl, PaginatedList } from 'utils/api';

export interface FilterOption {
  id: number;
  name: string;
}

export interface FilterOptionsListParams {
  name?: string;
  page: number;
  size: number;
  signal?: AbortSignal;
}

const SCHOOLS_PATH = '/resql-expert/admin/submissions/filter-options/schools';
const REPORTERS_PATH = '/resql-expert/admin/submissions/filter-options/reporters';
const EXPERTS_PATH = '/resql-expert/admin/submissions/filter-options/experts';

const buildListUrl = (path: string, { name, page, size }: FilterOptionsListParams): string => {
  const params = new URLSearchParams();
  if (name) params.set('name', name);
  params.set('page', page.toString());
  params.set('size', size.toString());
  return `${getApiUrl(path)}?${params.toString()}`;
};

const listOf = (path: string) => ({
  signal,
  ...params
}: FilterOptionsListParams): Promise<PaginatedList<FilterOption[]>> =>
  api(buildListUrl(path, params), { method: 'GET', signal });

const getOf = (path: string) => (id: number): Promise<FilterOption> =>
  api(getApiUrl(`${path}/${id}`), { method: 'GET' });

export const filterOptionsApi = {
  listSchools: listOf(SCHOOLS_PATH),
  listReporters: listOf(REPORTERS_PATH),
  listExperts: listOf(EXPERTS_PATH),
  getSchool: getOf(SCHOOLS_PATH),
  getReporter: getOf(REPORTERS_PATH),
  getExpert: getOf(EXPERTS_PATH),
};
